<template>
  <div class="account-section">
    <!-- v-bind:style="{ 'background-image': 'url(' + img + ')' }" -->
    <div class="cards">
      <div class="d-flex flex-wrap main-cards">
        <div
          class="card"
          v-for="(card, i) in cards"
          :key="i"
          @click="toogleCard($event, card)"
          :class="{ active: activeCards.indexOf(card.id) >= 0 }"
        >
          <div class="card-top">
            <span class="add">
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.3107 7.04297C16.7012 7.43349 16.7012 8.06666 16.3107 8.45718L10.1036 14.9572C9.71307 15.3477 9.0799 15.3477 8.68938 14.9572L5.68938 11.9572C5.29885 11.5667 5.29885 10.9335 5.68938 10.543C6.0799 10.1524 6.71307 10.1524 7.10359 10.543L9.39648 12.8359L14.8965 7.04297C15.287 6.65244 15.9202 6.65244 16.3107 7.04297Z"
                  fill="var(--theme-color)"
                />
              </svg>
            </span>
            <span class="del" @click="delCard(card.id)">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.3335 4.00033C1.3335 3.63214 1.63197 3.33366 2.00016 3.33366H14.0002C14.3684 3.33366 14.6668 3.63214 14.6668 4.00033C14.6668 4.36852 14.3684 4.66699 14.0002 4.66699H2.00016C1.63197 4.66699 1.3335 4.36852 1.3335 4.00033Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.66683 2.00033C6.49002 2.00033 6.32045 2.07056 6.19543 2.19559C6.0704 2.32061 6.00016 2.49018 6.00016 2.66699V3.33366H10.0002V2.66699C10.0002 2.49018 9.92992 2.32061 9.8049 2.19559C9.67988 2.07056 9.51031 2.00033 9.3335 2.00033H6.66683ZM11.3335 3.33366V2.66699C11.3335 2.13656 11.1228 1.62785 10.7477 1.25278C10.3726 0.877706 9.86393 0.666992 9.3335 0.666992H6.66683C6.1364 0.666992 5.62769 0.877706 5.25262 1.25278C4.87754 1.62785 4.66683 2.13656 4.66683 2.66699V3.33366H3.3335C2.96531 3.33366 2.66683 3.63214 2.66683 4.00033V13.3337C2.66683 13.8641 2.87754 14.3728 3.25262 14.7479C3.62769 15.1229 4.1364 15.3337 4.66683 15.3337H11.3335C11.8639 15.3337 12.3726 15.1229 12.7477 14.7479C13.1228 14.3728 13.3335 13.8641 13.3335 13.3337V4.00033C13.3335 3.63214 13.035 3.33366 12.6668 3.33366H11.3335ZM4.00016 4.66699V13.3337C4.00016 13.5105 4.0704 13.68 4.19543 13.8051C4.32045 13.9301 4.49002 14.0003 4.66683 14.0003H11.3335C11.5103 14.0003 11.6799 13.9301 11.8049 13.8051C11.9299 13.68 12.0002 13.5105 12.0002 13.3337V4.66699H4.00016Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.66683 6.66699C7.03502 6.66699 7.3335 6.96547 7.3335 7.33366V11.3337C7.3335 11.7018 7.03502 12.0003 6.66683 12.0003C6.29864 12.0003 6.00016 11.7018 6.00016 11.3337V7.33366C6.00016 6.96547 6.29864 6.66699 6.66683 6.66699Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.3335 6.66699C9.70169 6.66699 10.0002 6.96547 10.0002 7.33366V11.3337C10.0002 11.7018 9.70169 12.0003 9.3335 12.0003C8.96531 12.0003 8.66683 11.7018 8.66683 11.3337V7.33366C8.66683 6.96547 8.96531 6.66699 9.3335 6.66699Z"
                  fill="white"
                />
              </svg>
            </span>
          </div>
          <p class="content">{{ card.cardNumber }}</p>
          <div class="details">
            <span class="code">{{ card.cardV }}</span>
            <span class="date">{{ card.cardDate }}</span>
          </div>
        </div>
        <div class="add-card" @click="showAddTag">
          <span>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 4C12.5523 4 13 4.44772 13 5V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V5C11 4.44772 11.4477 4 12 4Z"
                fill="var(--theme-color)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z"
                fill="var(--theme-color)"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>
    <div class="accounts-nav">
      <h4>SUBCRIPTIONS</h4>
      <div class="status">
        <h6>Free <span> ($0/Mo)</span></h6>
        <span class="upgrade-now"> Upgrade </span>
      </div>
      <div
        class="overlay"
        v-if="showDropDown1"
        @click="showDropDown1 = false"
      ></div>
    </div>
    <div class="tags">
      <div class="sortTags">
        <div
          class="tag"
          v-for="(tag, i) in tags"
          :key="i"
          @click="handleTagChange(tag)"
          :class="{ active: activeTag == tag }"
        >
          {{ tag }}
        </div>
      </div>
      <div class="subscription">
        <span @click="activeInterval = 'month'">Monthly</span>
        <div
          class="toggler"
          @click="toggleInterval"
          :class="[activeInterval == 'year' ? 'bg' : '']"
        >
          <div
            class="slider"
            :class="[activeInterval == 'year' ? 'btns' : '']"
          ></div>
        </div>
        <span @click="activeInterval = 'year'">Yearly</span>
      </div>
    </div>
    <div class="pricing-cards">
      <div class="row">
        <div
          class="col-md-6 col-lg-4"
          v-for="(product, i) in activeProducts"
          :key="i"
        >
          <div
            v-if="product.interval == activeInterval"
            class="price-card d-flex flex-column align-items-center"
          >
            <h2>{{ product.description }}</h2>
            <h1 class="price">${{ product.unit_amount / 100 }}</h1>
            <h3 class="month">PER {{ product.interval.toUpperCase() }}</h3>
            <div class="features">
              <p>
                Advantages features
              </p>
              <p>
                Advantages features
              </p>
              <p>
                Advantages features
              </p>
              <p>
                Advantages features
              </p>
            </div>
            <b-button
              v-if="product.unit_amount !== 0"
              variant="primary btn-round-fill no-shadow"
              @click="subscribe(product)"
              :class="{ activee: !subscription }"
            >
              {{ subscription ? "Current Subcription" : "Subscribe" }}
            </b-button>
            <b-button
              v-if="product.unit_amount == 0 && activeTag == 'Guide'"
              variant="primary btn-round-fill no-shadow"
              @click="applyGuideRole(product)"
              :class="{ activee: !guideSubscription }"
            >
              {{ guideSubscription ? "Current Subcription" : "Subscribe" }}
            </b-button>
            <b-button
              v-if="product.unit_amount == 0 && activeTag == 'Blogger'"
              variant="primary btn-round-fill no-shadow"
              @click="applyBloggerRole(product)"
              :class="{ activee: !bloggerSubscription }"
            >
              {{ bloggerSubscription ? "Current Subcription" : "Subscribe" }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay" v-if="calendar" @click="calendar = false"></div>
    <div class="subscription_details">
      <h1>SUBCRIPTION PAYMENT</h1>
      <div class="d-flex justify-content-between flex-wrap transactions">
        <h5>Transactions</h5>
        <div class="transaction_details d-flex">
          <!--          <h6></h6>-->
          <div class="subscription report">
            <span @click="reportType = false">Full Report</span>
            <div
              class="toggler"
              @click="reportType = !reportType"
              :class="[reportType ? 'bg' : '']"
            >
              <div class="slider" :class="[reportType ? 'btns' : '']"></div>
            </div>
            <span @click="reportType = !reportType">By Date</span>
          </div>
          <transition name="fade">
            <div class="date_btn" @click="calendar = true" v-if="reportType">
              <span class="calender" @click="calendar = true"
                ><svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.3335 3.83366C2.96531 3.83366 2.66683 4.13214 2.66683 4.50033V13.8337C2.66683 14.2018 2.96531 14.5003 3.3335 14.5003H12.6668C13.035 14.5003 13.3335 14.2018 13.3335 13.8337V4.50033C13.3335 4.13214 13.035 3.83366 12.6668 3.83366H3.3335ZM1.3335 4.50033C1.3335 3.39576 2.22893 2.50033 3.3335 2.50033H12.6668C13.7714 2.50033 14.6668 3.39576 14.6668 4.50033V13.8337C14.6668 14.9382 13.7714 15.8337 12.6668 15.8337H3.3335C2.22893 15.8337 1.3335 14.9382 1.3335 13.8337V4.50033Z"
                    fill="#8D99A0"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.6668 1.16699C11.035 1.16699 11.3335 1.46547 11.3335 1.83366V4.50033C11.3335 4.86852 11.035 5.16699 10.6668 5.16699C10.2986 5.16699 10.0002 4.86852 10.0002 4.50033V1.83366C10.0002 1.46547 10.2986 1.16699 10.6668 1.16699Z"
                    fill="#8D99A0"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.3335 1.16699C5.70169 1.16699 6.00016 1.46547 6.00016 1.83366V4.50033C6.00016 4.86852 5.70169 5.16699 5.3335 5.16699C4.96531 5.16699 4.66683 4.86852 4.66683 4.50033V1.83366C4.66683 1.46547 4.96531 1.16699 5.3335 1.16699Z"
                    fill="#8D99A0"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.3335 7.16699C1.3335 6.7988 1.63197 6.50033 2.00016 6.50033H14.0002C14.3684 6.50033 14.6668 6.7988 14.6668 7.16699C14.6668 7.53518 14.3684 7.83366 14.0002 7.83366H2.00016C1.63197 7.83366 1.3335 7.53518 1.3335 7.16699Z"
                    fill="#8D99A0"
                  />
                </svg>
              </span>
              {{ st_date }}-{{ end_date }}
              <span class="down">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.11051 9.75256L5.78412 7.16768C5.61037 6.97462 5.74737 6.66699 6.0071 6.66699H10.6599C10.9196 6.66699 11.0566 6.97462 10.8829 7.16768L8.55648 9.75256C8.43731 9.88497 8.22968 9.88497 8.11051 9.75256Z"
                    fill="#474D52"
                  />
                </svg>
              </span>
              <!-- -->
              <div class="calendar_wrapper">
                <div style="position:relative;">
                  <b-calendar
                    v-if="calendar"
                    v-model="st_date_temp"
                    @constext="onContext"
                    id="st_report_calender"
                    :hide-header="true"
                    selected-variant="success"
                    block
                    today-variant="info"
                    :date-format-options="{
                      day: 'numeric',
                      year: 'numeric',
                      month: 'numeric'
                    }"
                    locale="en-US"
                  ></b-calendar>
                </div>
                <div style="position: relative">
                  <b-calendar
                    v-if="calendar"
                    v-model="end_date_temp"
                    @context="onContext"
                    id="end_report_calender"
                    :hide-header="true"
                    selected-variant="success"
                    block
                    today-variant="info"
                    :date-format-options="{
                      day: 'numeric',
                      year: 'numeric',
                      month: 'numeric'
                    }"
                    locale="en-US"
                  ></b-calendar>
                </div>
              </div>
            </div>
          </transition>
          <b-button class="email_btn">
            <span>
              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.6665 3.83333C2.30136 3.83333 1.99984 4.13486 1.99984 4.5V12.5C1.99984 12.8651 2.30136 13.1667 2.6665 13.1667H13.3332C13.6983 13.1667 13.9998 12.8651 13.9998 12.5V4.5C13.9998 4.13486 13.6983 3.83333 13.3332 3.83333H2.6665ZM0.666504 4.5C0.666504 3.39848 1.56498 2.5 2.6665 2.5H13.3332C14.4347 2.5 15.3332 3.39848 15.3332 4.5V12.5C15.3332 13.6015 14.4347 14.5 13.3332 14.5H2.6665C1.56498 14.5 0.666504 13.6015 0.666504 12.5V4.5Z"
                  fill="var(--theme-color)"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.787073 4.11742C0.998216 3.81579 1.4139 3.74243 1.71554 3.95358L7.99989 8.35263L14.2843 3.95358C14.5859 3.74243 15.0016 3.81579 15.2127 4.11742C15.4239 4.41906 15.3505 4.83474 15.0489 5.04589L8.3822 9.71255C8.15266 9.87324 7.84713 9.87324 7.61759 9.71255L0.95092 5.04589C0.649287 4.83474 0.57593 4.41906 0.787073 4.11742Z"
                  fill="var(--theme-color)"
                />
              </svg>
            </span>
            Email
          </b-button>
          <b-button class="download_btn download">
            <span
              ><svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.00016 9.83301C2.36835 9.83301 2.66683 10.1315 2.66683 10.4997V13.1663C2.66683 13.3432 2.73707 13.5127 2.86209 13.6377C2.98712 13.7628 3.15669 13.833 3.3335 13.833H12.6668C12.8436 13.833 13.0132 13.7628 13.1382 13.6377C13.2633 13.5127 13.3335 13.3432 13.3335 13.1663V10.4997C13.3335 10.1315 13.632 9.83301 14.0002 9.83301C14.3684 9.83301 14.6668 10.1315 14.6668 10.4997V13.1663C14.6668 13.6968 14.4561 14.2055 14.081 14.5806C13.706 14.9556 13.1973 15.1663 12.6668 15.1663H3.3335C2.80306 15.1663 2.29436 14.9556 1.91928 14.5806C1.54421 14.2055 1.3335 13.6968 1.3335 13.1663V10.4997C1.3335 10.1315 1.63197 9.83301 2.00016 9.83301Z"
                  fill="var(--theme-color)"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.19526 6.69526C4.45561 6.43491 4.87772 6.43491 5.13807 6.69526L8 9.55719L10.8619 6.69526C11.1223 6.43491 11.5444 6.43491 11.8047 6.69526C12.0651 6.95561 12.0651 7.37772 11.8047 7.63807L8.4714 10.9714C8.21106 11.2318 7.78894 11.2318 7.5286 10.9714L4.19526 7.63807C3.93491 7.37772 3.93491 6.95561 4.19526 6.69526Z"
                  fill="var(--theme-color)"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.00016 1.83301C8.36835 1.83301 8.66683 2.13148 8.66683 2.49967V10.4997C8.66683 10.8679 8.36835 11.1663 8.00016 11.1663C7.63197 11.1663 7.3335 10.8679 7.3335 10.4997V2.49967C7.3335 2.13148 7.63197 1.83301 8.00016 1.83301Z"
                  fill="var(--theme-color)"
                />
              </svg>
            </span>
            Download
          </b-button>
        </div>
      </div>
      <div class="subscription_list">
        <div class="single_list d-flex justify-content-between flex-wrap">
          <p>YouTube Viewer Subscription</p>
          <div class="list_details">
            <span class="sub_price">$1</span>
            <b-button class="email_btn">
              <span>
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.6665 3.83333C2.30136 3.83333 1.99984 4.13486 1.99984 4.5V12.5C1.99984 12.8651 2.30136 13.1667 2.6665 13.1667H13.3332C13.6983 13.1667 13.9998 12.8651 13.9998 12.5V4.5C13.9998 4.13486 13.6983 3.83333 13.3332 3.83333H2.6665ZM0.666504 4.5C0.666504 3.39848 1.56498 2.5 2.6665 2.5H13.3332C14.4347 2.5 15.3332 3.39848 15.3332 4.5V12.5C15.3332 13.6015 14.4347 14.5 13.3332 14.5H2.6665C1.56498 14.5 0.666504 13.6015 0.666504 12.5V4.5Z"
                    fill="var(--theme-color)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.787073 4.11742C0.998216 3.81579 1.4139 3.74243 1.71554 3.95358L7.99989 8.35263L14.2843 3.95358C14.5859 3.74243 15.0016 3.81579 15.2127 4.11742C15.4239 4.41906 15.3505 4.83474 15.0489 5.04589L8.3822 9.71255C8.15266 9.87324 7.84713 9.87324 7.61759 9.71255L0.95092 5.04589C0.649287 4.83474 0.57593 4.41906 0.787073 4.11742Z"
                    fill="var(--theme-color)"
                  />
                </svg>
              </span>
              Email
            </b-button>
            <b-button class="download_btn download">
              <span
                ><svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.00016 9.83301C2.36835 9.83301 2.66683 10.1315 2.66683 10.4997V13.1663C2.66683 13.3432 2.73707 13.5127 2.86209 13.6377C2.98712 13.7628 3.15669 13.833 3.3335 13.833H12.6668C12.8436 13.833 13.0132 13.7628 13.1382 13.6377C13.2633 13.5127 13.3335 13.3432 13.3335 13.1663V10.4997C13.3335 10.1315 13.632 9.83301 14.0002 9.83301C14.3684 9.83301 14.6668 10.1315 14.6668 10.4997V13.1663C14.6668 13.6968 14.4561 14.2055 14.081 14.5806C13.706 14.9556 13.1973 15.1663 12.6668 15.1663H3.3335C2.80306 15.1663 2.29436 14.9556 1.91928 14.5806C1.54421 14.2055 1.3335 13.6968 1.3335 13.1663V10.4997C1.3335 10.1315 1.63197 9.83301 2.00016 9.83301Z"
                    fill="var(--theme-color)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.19526 6.69526C4.45561 6.43491 4.87772 6.43491 5.13807 6.69526L8 9.55719L10.8619 6.69526C11.1223 6.43491 11.5444 6.43491 11.8047 6.69526C12.0651 6.95561 12.0651 7.37772 11.8047 7.63807L8.4714 10.9714C8.21106 11.2318 7.78894 11.2318 7.5286 10.9714L4.19526 7.63807C3.93491 7.37772 3.93491 6.95561 4.19526 6.69526Z"
                    fill="var(--theme-color)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.00016 1.83301C8.36835 1.83301 8.66683 2.13148 8.66683 2.49967V10.4997C8.66683 10.8679 8.36835 11.1663 8.00016 11.1663C7.63197 11.1663 7.3335 10.8679 7.3335 10.4997V2.49967C7.3335 2.13148 7.63197 1.83301 8.00016 1.83301Z"
                    fill="var(--theme-color)"
                  />
                </svg>
              </span>
              Download
            </b-button>
          </div>
        </div>
        <div class="single_list d-flex justify-content-between flex-wrap">
          <p>YouTube Viewer Subscription</p>
          <div class="list_details">
            <span class="sub_price">$1</span>
            <b-button class="email_btn">
              <span>
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.6665 3.83333C2.30136 3.83333 1.99984 4.13486 1.99984 4.5V12.5C1.99984 12.8651 2.30136 13.1667 2.6665 13.1667H13.3332C13.6983 13.1667 13.9998 12.8651 13.9998 12.5V4.5C13.9998 4.13486 13.6983 3.83333 13.3332 3.83333H2.6665ZM0.666504 4.5C0.666504 3.39848 1.56498 2.5 2.6665 2.5H13.3332C14.4347 2.5 15.3332 3.39848 15.3332 4.5V12.5C15.3332 13.6015 14.4347 14.5 13.3332 14.5H2.6665C1.56498 14.5 0.666504 13.6015 0.666504 12.5V4.5Z"
                    fill="var(--theme-color)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.787073 4.11742C0.998216 3.81579 1.4139 3.74243 1.71554 3.95358L7.99989 8.35263L14.2843 3.95358C14.5859 3.74243 15.0016 3.81579 15.2127 4.11742C15.4239 4.41906 15.3505 4.83474 15.0489 5.04589L8.3822 9.71255C8.15266 9.87324 7.84713 9.87324 7.61759 9.71255L0.95092 5.04589C0.649287 4.83474 0.57593 4.41906 0.787073 4.11742Z"
                    fill="var(--theme-color)"
                  />
                </svg>
              </span>
              Email
            </b-button>
            <b-button class="download_btn download">
              <span
                ><svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.00016 9.83301C2.36835 9.83301 2.66683 10.1315 2.66683 10.4997V13.1663C2.66683 13.3432 2.73707 13.5127 2.86209 13.6377C2.98712 13.7628 3.15669 13.833 3.3335 13.833H12.6668C12.8436 13.833 13.0132 13.7628 13.1382 13.6377C13.2633 13.5127 13.3335 13.3432 13.3335 13.1663V10.4997C13.3335 10.1315 13.632 9.83301 14.0002 9.83301C14.3684 9.83301 14.6668 10.1315 14.6668 10.4997V13.1663C14.6668 13.6968 14.4561 14.2055 14.081 14.5806C13.706 14.9556 13.1973 15.1663 12.6668 15.1663H3.3335C2.80306 15.1663 2.29436 14.9556 1.91928 14.5806C1.54421 14.2055 1.3335 13.6968 1.3335 13.1663V10.4997C1.3335 10.1315 1.63197 9.83301 2.00016 9.83301Z"
                    fill="var(--theme-color)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.19526 6.69526C4.45561 6.43491 4.87772 6.43491 5.13807 6.69526L8 9.55719L10.8619 6.69526C11.1223 6.43491 11.5444 6.43491 11.8047 6.69526C12.0651 6.95561 12.0651 7.37772 11.8047 7.63807L8.4714 10.9714C8.21106 11.2318 7.78894 11.2318 7.5286 10.9714L4.19526 7.63807C3.93491 7.37772 3.93491 6.95561 4.19526 6.69526Z"
                    fill="var(--theme-color)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.00016 1.83301C8.36835 1.83301 8.66683 2.13148 8.66683 2.49967V10.4997C8.66683 10.8679 8.36835 11.1663 8.00016 11.1663C7.63197 11.1663 7.3335 10.8679 7.3335 10.4997V2.49967C7.3335 2.13148 7.63197 1.83301 8.00016 1.83301Z"
                    fill="var(--theme-color)"
                  />
                </svg>
              </span>
              Download
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="tag-modal"
      @hide="clearForm"
      hide-footer
      hide-header
      body-class="p-0"
      centered
      class="my_modal"
    >
      <!-- Header -->
      <div class="form-header">
        <span @click="$bvModal.hide('tag-modal')" class="close">
          <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="17" cy="17" r="17" fill="#E4E6EB" />
            <g clip-path="url(#clip0)">
              <path
                d="M17.8348 17.0009L24.3827 10.453C24.6132 10.2225 24.6132 9.84872 24.3827 9.61821C24.1522 9.38771 23.7784 9.38768 23.5479 9.61821L17 16.1661L10.4522 9.61821C10.2216 9.38768 9.84786 9.38768 9.61736 9.61821C9.38685 9.84874 9.38682 10.2225 9.61736 10.453L16.1652 17.0009L9.61736 23.5487C9.38682 23.7793 9.38682 24.153 9.61736 24.3835C9.73261 24.4988 9.88369 24.5564 10.0348 24.5564C10.1859 24.5564 10.3369 24.4988 10.4522 24.3835L17 17.8357L23.5479 24.3835C23.6631 24.4988 23.8142 24.5564 23.9653 24.5564C24.1164 24.5564 24.2674 24.4988 24.3827 24.3835C24.6132 24.153 24.6132 23.7792 24.3827 23.5487L17.8348 17.0009Z"
                fill="#606770"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="15.1111"
                  height="15.1111"
                  fill="white"
                  transform="translate(9.44446 9.44434)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
        <h2 class="text-center">{{ edit ? "Edit" : "Add" }} Card Details</h2>
        <b-form class="form">
          <b-form-group>
            <b-form-input
              id="input-1"
              type="text"
              required
              placeholder="Card Number"
              class="custom_input"
              v-model="cardData.cardNumber"
            ></b-form-input>
          </b-form-group>
          <div class="w50">
            <b-form-group>
              <b-form-input
                type="text"
                required
                placeholder="MM/YY"
                class="custom_input"
                v-model="cardData.cardDate"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-1">
              <b-form-input
                type="text"
                required
                placeholder="CVV"
                class="custom_input"
                v-model="cardData.cardV"
              ></b-form-input>
            </b-form-group>
          </div>

          <b-form-group>
            <b-form-input
              type="text"
              required
              placeholder="Name on Card"
              class="custom_input"
              v-model="cardData.cardName"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <b-form-input
              type="text"
              required
              placeholder="Address 1"
              class="custom_input"
              v-model="cardData.address1"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <b-form-input
              type="text"
              required
              placeholder="Address 2"
              class="custom_input"
              v-model="cardData.address2"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <b-form-input
              type="text"
              required
              placeholder="City"
              class="custom_input"
              v-model="cardData.city"
            ></b-form-input>
          </b-form-group>
          <div class="w50">
            <b-form-group>
              <b-form-input
                type="text"
                required
                placeholder="State"
                class="custom_input"
                v-model="cardData.state"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-2">
              <b-form-input
                type="text"
                required
                placeholder="Zip Code"
                class="custom_input"
                v-model="cardData.zip"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="foot">
            <b-button
              v-if="!edit"
              variant="primary btn-round-fill"
              @click="addCard"
              >Add</b-button
            >
            <b-button
              v-if="edit"
              variant="primary btn-round-fill"
              @click="editCards"
              >Edit</b-button
            >
          </div>
        </b-form>
      </div>
      <!-- Header -->
    </b-modal>
    <modal id="deleteCard" size="sm">
      <div class="add-faq del-faq">
        <span class="close-icon" @click="$bvModal.hide('deleteCard')">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
            <g clip-path="url(#clip0)">
              <path
                d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                fill="#606770"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="10.6667"
                  height="10.6667"
                  fill="white"
                  transform="translate(6.6665 6.66675)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
        <h3>Delete Card</h3>
        <div class="warning-msg">
          <p>Are you sure want to delete this Card?</p>
        </div>
        <div class="d-flex justify-content-between">
          <b-button
            variant="danger btn-round-fill"
            @click="$bvModal.hide('deleteCard')"
          >
            No! back
          </b-button>
          <b-button variant="light btn-simple" @click="deleteCard">
            Yes! Delete
          </b-button>
          <!-- light btn-simple -->
        </div>
      </div>
    </modal>
    <modal id="subscribe" size="sm">
      <div class="add-faq del-faq">
        <span class="close-icon" @click="$bvModal.hide('subscribe')">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
            <g clip-path="url(#clip0)">
              <path
                d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                fill="#606770"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="10.6667"
                  height="10.6667"
                  fill="white"
                  transform="translate(6.6665 6.66675)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
        <h3>Payment Details</h3>
        <div class="warning-msg">
          <div>
            <div class="card-element" id="card-element"></div>
            <div class="card-errors" id="card-errors" role="alert"></div>
          </div>

          <!-- <p>
            We will Charge your card on file XXXX-1234 for the Starter
            Subscription
          </p> -->
        </div>
        <div class="d-flex justify-content-between">
          <b-button
            variant=" lightFont btn-simple"
            @click="$bvModal.hide('subscribe')"
          >
            Cancel
          </b-button>
          <b-button variant="light btn-round-fill" @click="confirmSubscribe">
            Subscribe
          </b-button>
          <!-- light btn-simple -->
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
var card;
import firebase from "firebase";
import { mapGetters } from "vuex";
import Modal from "@/components/common/modal";
export default {
  name:"Me_Accounts",
  data() {
    return {
      cards: [],
      add: true,
      edit: false,
      year: true,
      reportType: false,
      month: true,
      calendar: false,
      primary: "primary",
      st_date: "12/12/2020",
      st_date_temp: "12/12/2020",
      end_date: "12/12/2020",
      end_date_temp: "12/12/2020",
      btnRoundFill: "btn-round-fill",
      activeCards: [],
      deleteIndex: "",
      showDropDown1: false,
      tags: ["Guide", "Blogger", "Member"],
      activeTag: "Guide",
      updateIndex: -1,
      member: "Member",
      name: "",
      editIndex: -1,
      editedCard: undefined,
      cardData: {
        cardNumber: "",
        cardDate: "",
        cardV: "",
        id: "",
        cardName: "",
        address1: "",
        address2: "",
        promoCode: "",
        city: "",
        state: "",
        zip: ""
      },
      activeInterval: "month",
      stripe: null,
      customerId: null,
      products: [],
      activeProducts: [],
      showCheckout: false,
      subscribing: false,
      unSubscribing: false,
      subscribedSuccess: false,
      guideSubscription: false,
      bloggerSubscription: false
    };
  },
  mounted() {
    this.getCustomerId();
    this.getProducts();
    this.checkSubscription();
    this.checkGuideSubscription();
    this.checkBloggerSubscription();
  },
  computed: {
    ...mapGetters({
      subscription: "stripe/subscription",
      user: "user/profile"
    })
  },
  watch: {
    calendar(n) {
      if (!n) {
        (this.st_date = this.st_date_temp),
          (this.end_date = this.end_date_temp);
      }
    }
  },
  methods: {
    checkSubscription() {
      this.$store.dispatch("stripe/checkSubscription", {
        uid: this.user.userId
      });
    },
    getCustomerId() {
      const db = firebase.firestore();
      let userRef = db.collection("customers").doc(this.user.userId);
      userRef.get().then(doc => {
        if (doc.exists) {
          this.customerId = doc.data().stripeId;
        }
      });
    },
    getProducts() {
      const db = firebase.firestore();
      db.collection("products")
        .get()
        .then(productSnapshot => {
          productSnapshot.forEach(productDoc => {
            let productInfo = {
              productId: productDoc.id,
              ...productDoc.data()
            };
            db.collection("products")
              .doc(productDoc.id)
              .collection("prices")
              .get()
              .then(priceSnapshot => {
                priceSnapshot.forEach(priceDoc => {
                  let priceInfo = {
                    priceId: priceDoc.id,
                    ...priceDoc.data()
                  };
                  let info = { ...productInfo, ...priceInfo };
                  this.products.push(info);
                  if (info.name == "Guide") {
                    this.activeProducts.push(info);
                  }
                });
              });
            this.addCardElement();
            console.log(this.products);
          });
        });
    },
    addCardElement() {
      this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_PK);
      let elements = this.stripe.elements();
      card = elements.create("card");
      card.mount("#card-element");
      card.on("change", ({ error }) => {
        const displayError = document.getElementById("card-errors");
        if (error) {
          displayError.textContent = error.message;
        } else {
          displayError.textContent = "";
        }
      });
    },
    confirmSubscribe() {
      this.subscribing = true;
      const latestInvoicePaymentIntentStatus = localStorage.getItem(
        "latestInvoicePaymentIntentStatus"
      );

      if (latestInvoicePaymentIntentStatus === "requires_payment_method") {
        const invoiceId = localStorage.getItem("latestInvoiceId");
        const isPaymentRetry = true;
        this.createPaymentMethod({
          card,
          isPaymentRetry,
          invoiceId
        });
      } else {
        this.createPaymentMethod({ card });
      }
    },
    createPaymentMethod({ card, isPaymentRetry, invoiceId }) {
      this.stripe
        .createPaymentMethod({
          type: "card",
          card: card,
          billing_details: {
            name: this.user.firstname,
            email: this.user.email
          }
        })
        .then(result => {
          if (result.error) {
            this.subscribing = false;
            this.$store.dispatch("user/showNotification", {
              title: "Oops an error occured. Please try again.",
              description: result.error.message,
              variant: "danger"
            });
          } else {
            if (isPaymentRetry) {
              this.retryInvoiceWithNewPaymentMethod({
                customerId: this.customerId,
                paymentMethodId: result.paymentMethod.id,
                invoiceId: invoiceId,
                priceId: this.selectedProduct.priceId
              });
            } else {
              this.createSubscription({
                customerId: this.customerId,
                paymentMethodId: result.paymentMethod.id,
                priceId: this.selectedProduct.priceId
              });
            }
          }
        })
        .catch(error => {
          this.subscribing = false;
          this.$store.dispatch("user/showNotification", {
            title: "Something went wrong. Please try later",
            description: error.message,
            variant: "danger"
          });
        });
    },
    createSubscription({ customerId, paymentMethodId, priceId }) {
      let func = firebase.functions().httpsCallable("createSubscription");
      func({
        customerId: customerId,
        paymentMethodId: paymentMethodId,
        priceId: priceId
      })
        .then(response => {
          console.log(response);
          if (response.error) {
            this.subscribing = false;
            this.$store.dispatch("user/showNotification", {
              title: "Something went wrong. Please try later",
              description: response.error.message,
              variant: "danger"
            });
          } else {
            this.handlePaymentThatRequiresCustomerAction({
              paymentMethodId: paymentMethodId,
              priceId: priceId,
              subscription: response.data
            })
              .then(result => {
                if (result == "success") {
                  this.subscribing = false;
                  this.subscribedSuccess = true;
                }
              })
              .catch(error => {
                this.subscribing = false;
                this.handleRequiresPaymentMethod({
                  paymentMethodId: paymentMethodId,
                  priceId: priceId,
                  subscription: response.data
                });
                this.$store.dispatch("user/showNotification", {
                  title: "Something went wrong. Please try later",
                  description: error.message,
                  variant: "danger"
                });
              });
          }
        })
        .catch(error => {
          this.subscribing = false;
          this.$store.dispatch("user/showNotification", {
            title: "Something went wrong. Please try later",
            description: error.message,
            variant: "danger"
          });
        });
    },
    retryInvoiceWithNewPaymentMethod({
      customerId,
      paymentMethodId,
      invoiceId,
      priceId
    }) {
      let func = firebase.functions().httpsCallable("retrySubscriptionInvoice");
      func({
        customerId: customerId,
        paymentMethodId: paymentMethodId,
        invoiceId: invoiceId
      })
        .then(response => {
          if (response.error) {
            this.subscribing = false;
            this.$store.dispatch("user/showNotification", {
              title: "Something went wrong. Please try later",
              description: response.error.message,
              variant: "danger"
            });
          } else {
            this.handlePaymentThatRequiresCustomerAction({
              invoice: response.data,
              paymentMethodId: paymentMethodId,
              priceId: priceId,
              isRetry: true
            })
              .then(result => {
                if (result == "success") {
                  this.subscribing = false;
                  this.subscribedSuccess = true;
                }
              })
              .catch(error => {
                this.subscribing = false;
                this.handleRequiresPaymentMethod({
                  paymentMethodId: paymentMethodId,
                  priceId: priceId,
                  subscription: response.data
                });
                this.$store.dispatch("user/showNotification", {
                  title: "Something went wrong. Please try later",
                  description: error.message,
                  variant: "danger"
                });
              });
          }
        })
        .catch(error => {
          this.subscribing = false;
          this.$store.dispatch("user/showNotification", {
            title: "Something went wrong. Please try later",
            description: error.message,
            variant: "danger"
          });
        });
    },
    handlePaymentThatRequiresCustomerAction({
      subscription,
      invoice,
      priceId,
      paymentMethodId,
      isRetry
    }) {
      return new Promise((resolve, reject) => {
        if (subscription && subscription.status === "active") {
          resolve("success");
        }
        let paymentIntent = invoice
          ? invoice.payment_intent
          : subscription.latest_invoice.payment_intent;

        if (
          paymentIntent.status === "requires_action" ||
          (isRetry === true &&
            paymentIntent.status === "requires_payment_method")
        ) {
          this.stripe
            .confirmCardPayment(paymentIntent.client_secret, {
              payment_method: paymentMethodId
            })
            .then(result => {
              if (result.error) {
                reject(result.error);
              } else {
                if (result.paymentIntent.status === "succeeded") {
                  resolve("success");
                }
              }
            })
            .catch(error => {
              reject(error);
            });
        } else {
          resolve("success");
        }
      });
    },
    handleRequiresPaymentMethod({ subscription, paymentMethodId, priceId }) {
      if (subscription.status === "active") {
        return;
      } else if (
        subscription.latest_invoice.payment_intent.status ===
        "requires_payment_method"
      ) {
        localStorage.setItem("latestInvoiceId", subscription.latest_invoice.id);
        localStorage.setItem(
          "latestInvoicePaymentIntentStatus",
          subscription.latest_invoice.payment_intent.status
        );
        throw { error: { message: "Your card was declined." } };
      } else {
        return;
      }
    },
    closeSucessNote() {
      this.subscribedSuccess = false;
      this.addCardElement();
    },
    cancelSubscription() {
      this.subscribing = true;
      let func = firebase.functions().httpsCallable("cancelSubscription");
      func({
        subscriptionId: "sub_id"
      })
        .then(response => {
          this.subscribing = false;
          console.log("display cancel note");
        })
        .catch(error => {
          this.subscribing = false;
          this.$store.dispatch("user/showNotification", {
            title: "Something went wrong. Please try later",
            description: error.message,
            variant: "danger"
          });
        });
    },
    subscribe(product) {
      this.$bvModal.show("subscribe");
      setTimeout(() => {
        //   this.addCardElement();
      }, 1000);
    },
    applyGuideRole() {
      if (this.guideSubscription) return;
      this.$store
        .dispatch("listings/guideApply", this.user.userId)
        .then(() => {
          this.$store.dispatch("user/updateGuideDashboard").then(() => {
            this.$nprogress.done();
            this.$store.dispatch("user/showNotification", {
              title: "Successfully Subscribed",
              description: "You have successfully subscribed to free plan.",
              variant: "success"
            });
            this.checkGuideSubscription();
          });
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    applyBloggerRole() {
      if (this.bloggerSubscription) return;
      this.$store
        .dispatch("listings/bloggerApply", this.user.userId)
        .then(() => {
          this.$store.dispatch("user/updateBloggerDashboard").then(() => {
            this.$nprogress.done();
            this.$store.dispatch("user/showNotification", {
              title: "Successfully Subscribed",
              description: "You have successfully subscribed to free plan.",
              variant: "success"
            });
            this.checkBloggerSubscription();
          });
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    checkGuideSubscription() {
      this.$store
        .dispatch("listings/getGuideById", this.user)
        .then(guide => {
          if (guide) {
            this.guideSubscription = true;
          }
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    checkBloggerSubscription() {
      this.$store
        .dispatch("listings/getBloggerById", this.user)
        .then(guide => {
          if (guide) {
            this.bloggerSubscription = true;
          }
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    onContext(ctx) {
      this.context = ctx;
      let date = ctx.activeFormatted;
      this.date = date;
    },
    // confirmSubscribe() {
    //   this.$bvModal.hide("subscribe");
    // },
    showAddTag() {
      this.del = false;
      this.add = true;
      this.edit = false;
      this.$bvModal.show("tag-modal");
    },
    showDrop(value) {
      if (value == "showDropDown1") {
        this.showDropDown1 = !this.showDropDown1;
      }
      if (value == "showDropDown2") {
        this.showDropDown2 = !this.showDropDown2;
      }
    },
    handleTagChange(tag) {
      this.activeProducts = [];
      this.activeTag = tag;
      this.products.forEach(product => {
        if (product.name == tag) {
          this.activeProducts.push(product);
        }
      });
    },
    toggleInterval() {
      if (this.activeInterval == "month") {
        this.activeInterval = "year";
      } else {
        this.activeInterval = "month";
      }
    },
    toogleCard(e, card) {
      if (e.target.tagName === "path" || e.target.tagName === "svg") {
        return;
      } else {
        this.activeCards = [];
        this.activeCards.push(card.id);
        this.edit = true;
        this.editCard(card.id);
        for (let key in card) {
          if (key == "id") continue;
          this.cardData[key] = card[key];
        }
        console.log(this.cardData);
        this.cards.forEach((card, i) => {
          // if (card.id == id) {
          // }
        });
      }
    },
    editCard(id) {
      let ecard;
      this.cards.forEach((card, i) => {
        if (card.id == id) {
          // console.log(card);
          ecard = card;
        }
      });
      this.$bvModal.show("tag-modal");
      let index = this.cards.indexOf(ecard);
      this.editedCard = ecard;
      this.editIndex = index;
      // this.cards[this.editIndex] = ecard;
    },
    editCards() {
      this.cardData.id = this.editedCard.id;
      this.cardData.address1 = this.editedCard.address1;
      this.cardData.address2 = this.editedCard.address2;
      this.cardData.cardName = this.editedCard.cardName;
      // console.log(this.cardData);
      // console.log(this.editedCard);
      this.cards[this.editIndex] = this.cardData;
      console.log(this.cards);
      this.editIndex = -1;
      this.editedCard = undefined;
      this.cardData = {
        cardNumber: "",
        cardDate: "",
        cardV: "",
        id: "",
        cardName: "",
        address1: "",
        address2: "",
        promoCode: ""
      };
      this.$bvModal.hide("tag-modal");
    },
    clearForm() {
      this.cardData = {
        cardNumber: "",
        cardDate: "",
        cardV: "",
        id: "",
        cardName: "",
        address1: "",
        address2: "",
        promoCode: ""
      };
    },
    addCard() {
      this.cardData.id = this.cardId();
      this.cards.push(this.cardData);
      // console.log(this.cards);
      this.cardData = {
        cardNumber: "",
        cardDate: "",
        cardV: "",
        id: "",
        cardName: "",
        address1: "",
        address2: "",
        promoCode: ""
      };
      this.$bvModal.hide("tag-modal");
    },
    cardId() {
      const id = this.cards.length + 1;
      return id;
    },
    delCard(id) {
      this.$bvModal.show("deleteCard");
      this.deleteIndex = id;
    },
    deleteCard() {
      this.cards.forEach((card, i) => {
        if (card.id === this.deleteIndex) {
          this.cards.splice(card, 1);
        }
      });
      this.deleteIndex = "";
      this.$bvModal.hide("deleteCard");
    }
  },
  components: {
    Modal
  }
};
</script>

<style lang="scss" scoped>
.price-card {
  .btn-round-fill {
    font-weight: 700 !important;
    &:hover {
      background: var(--theme-color);
    }
  }
}
.account-section {
  margin-top: 24px;
  font-family: "Nunito", sans-serif;
  font-family: "Inconsolata", monospace;
  @media (max-width: 667px) {
    .main-cards {
      justify-content: center;
      flex-direction: column-reverse;
      align-items: center;
    }
  }
  .card {
    cursor: pointer;
    background-color: #ffffff;
    // font-family: "Inconsolata", sans-serif;
    border-radius: 8px;
    border-radius: 8px;
    max-width: 256px;

    margin-bottom: 10px;
    width: 100%;
    height: 126px;
    background-repeat: no-repeat;
    filter: drop-shadow(0px 6px 16px rgba(0, 0, 0, 0.16));
    margin-right: 24px;
    z-index: 1;
    border: none;
    position: relative;
    overflow: hidden;
    &::after {
      // background-image: url("../../assets/circlebg.svg");
      content: "";
      position: absolute;
      top: 47px;
      right: -38px;
      right: -141px;
      bottom: -50px;
      background-repeat: no-repeat;
      width: 100%;
      height: 100%;
    }
    &.active {
      background-color: var(--theme-color);
      overflow: hidden;
      .card-top {
        .del {
          cursor: pointer;
          // pointer-events: none;
        }
        .del svg path {
          fill: #fff;
          pointer-events: none;
        }
        .add {
          opacity: 1;
        }
      }
      .content {
        color: #ffffff;
      }
      .details {
        span {
          color: rgba(255, 255, 255, 0.7);
          // opacity: 0.7;
        }
      }
    }

    .card-top {
      margin-top: 17px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 25px;
      padding-right: 25px;
      .del {
        cursor: pointer;
      }
      .del svg path {
        fill: #b3c2cb;
      }
      .add {
        // fill: #fff;
        opacity: 0;
      }
    }
    .content {
      font-family: "Inconsolata", sans-serif;
      padding-left: 25px;
      font-weight: 500;
      font-size: 20px;
      font-style: normal;
      line-height: 21px;
      display: flex;
      align-items: center;
      letter-spacing: 0.05em;
      color: #474d52;
      margin-top: 13px;
      margin-bottom: 0;
    }
    .details {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 25px;
      padding-right: 25px;
      padding-bottom: 12px;
      span {
        font-family: "Inconsolata", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 17px;
        display: flex;
        align-items: center;

        color: #b3c2cb;
      }
    }
  }
  .add-card {
    width: 42px;
    height: 42px;
    background: rgba(85, 126, 251, 0.2);
    // opacity: 0.2;
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: auto;
    margin-bottom: auto;
    @media (max-width: 667px) {
      margin-bottom: 20px;
    }
  }
}
.form-header {
  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    margin-top: 24px;

    color: #474d52;
  }
  .close {
    margin-right: 24px;
    cursor: pointer;
  }
}
.form {
  max-width: 390px;
  width: 100%;
  margin: 32px auto;
  .custom_label {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    width: 100%;
    color: var(--theme-color);
  }
  .custom_input {
    background: #ffffff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 100px;
    border: none;
    outline: none;
    padding: 13px 21px;
    height: 48px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #474d52;
    &:focus {
      border: none;
      outline: none;
    }
    &::placeholder {
      font-weight: 600;
      font-size: 14px;
      color: #a1b1ba;
      margin-bottom: 8px;
    }
  }
  label {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;

    /* Primary */

    color: var(--theme-color);
  }
  .w50 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
    // margin-bottom: 1rem;
    // margin-top: 1rem;
  }
  .btn-round-fill {
    max-width: 381px;

    width: 100%;
    height: 48px;
    background: var(--theme-color);
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.07);
    border-radius: 100px !important;
  }
  .foot {
    text-align: center;
    // margin-top: 296px;
  }
}
.accounts-nav {
  margin-top: 32px;
  // margin-bottom: 24px;
  display: flex;
  align-items: center;
  font-family: "Nunito", sans-serif;
  flex-wrap: wrap;
  h4 {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;

    display: flex;
    align-items: center;
    letter-spacing: 0.05em;
    color: #474d52;
  }
  .status {
    margin-left: 24px;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
      span {
        color: #8d99a0;
        padding-left: 3px;
      }
    }
    .upgrade-now {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;

      display: flex;
      align-items: center;
      color: var(--theme-color);
      padding-left: 8px;
      padding-bottom: 8px;
    }
  }
  .type {
    margin-left: 36px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    span {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;

      display: flex;
      align-items: center;

      color: #8d99a0;
    }
  }
  .select-custom {
    -webkit-appearance: none;
    -moz-appearance: none;
    background: transparent;
    background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-repeat: no-repeat;
    background-position-x: 98%;
    background-position-y: 50%;
    position: relative;
    width: 100px;
    border: none;
    font-family: "Nunito", sans-serif;
    font-family: "Nunito", sans-serif;
    font-weight: 600;
    font-style: normal;
    cursor: pointer;
    .custom_dropdown {
      list-style: none;
      font-family: "Nunito", sans-serif;
      font-weight: 600;
      font-style: normal;
      position: absolute;
      background-color: #fff;
      z-index: 99;
      margin-top: 13px;
      width: 120px;
      left: 0;
      border-radius: 5px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: column;
      height: 100px;
      // transform: translateY(10px);
      transition: 0.4s linear;
      padding: 0;
      cursor: pointer !important;
      cursor: pointer;
      background: #ffffff;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      padding: 12px;
      li {
        width: 100%;
        height: 100%;
        display: flex;
        // justify-content: center;
        align-items: center;
        // border-radius: 8px;
        transition: 0.4s linear;
        &:hover span {
          color: var(--theme-color);
        }

        span {
          color: #474d52;
          text-decoration: none;
          transition: 0.4s linear;
          pointer-events: none;
          &:hover {
            color: #fff;
          }
        }
      }
    }
    .myButton {
      border: none;
      outline: none;
      background: none;
    }
    // padding-top: 0;
  }
}
.tags {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 35px;
  @media (max-width: 560px) {
    align-items: center;
    flex-direction: column;
  }
  @media (max-width: 450px) {
    margin-left: auto;
    margin-right: auto;
    // display: block;
  }
  .sortTags {
    display: flex;
    flex-wrap: wrap;
    @media (max-width: 480px) {
      // margin-left: auto;
      flex-direction: column;
      .tag {
        text-align: center;
        margin-bottom: 10px;
      }
    }
  }
  .tag {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px;
    height: 35px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    background-color: #fff;
    color: #5b606c;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 32px;
    margin-right: 16px;
    &.active {
      background: rgba(85, 126, 251, 0.1);
      color: var(--theme-color);
      box-shadow: none;
    }
  }
}
.pricing-cards {
  font-family: "Nunito", sans-serif;
}

.subscription {
  display: flex;
  align-items: center;
  margin-top: 15px;
  &.report {
    width: 230px;
    margin-top: 0 !important;
  }
  span {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #474d52;
    font-family: "Nunito", sans-serif;
    cursor: pointer;
  }
  .toggler {
    @media (max-width: 874px) {
      // margin-bottom: 10px;
      margin-left: 15px;
    }
    margin: 0 8px;
    cursor: pointer;
    position: relative;
    display: inline-block;
    width: 46.5px;
    height: 24px;
    background: #f3f6f9;
    border-radius: 18px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #b3c2cb;
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
  .bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .btns {
    left: 50%;
    background: var(--theme-color);
    box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
  }
}
.overlay {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  // background: ;
}
.subscription_details {
  margin-top: 16px;
  font-family: "Nunito", sans-serif;
  h1 {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    letter-spacing: 0.05em;

    color: #474d52;
  }
  .transactions {
    margin-top: 10px;
    margin-bottom: 20px;
    @media (max-width: 420px) {
      flex-direction: column;
      align-items: center;
    }
    h5 {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      display: flex;
      align-items: center;

      color: #8d99a0;
      margin: 0;
    }
    .transaction_details {
      display: flex;
      align-items: center;
      @media (max-width: 600px) {
        flex-wrap: wrap;
      }
      @media (max-width: 420px) {
        flex-direction: column;
        align-items: center;
      }
      h6 {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        display: flex;
        margin-bottom: 0;
        align-items: center;
        color: #8d99a0;
        justify-content: center;
        margin-right: 38px;
        width: 120px;
        @media (max-width: 530px) {
          margin-right: 28px;
        }
        @media (max-width: 420px) {
          margin-right: 0px;
        }
      }
      .date_btn {
        cursor: pointer;
        position: relative;
        max-width: 224px;
        width: 100%;
        height: 35px;
        background: #f3f6f9;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        color: #474d52;
        line-height: 35px;
        &:hover {
          background: rgba(85, 126, 251, 0.1);
        }
        @media (max-width: 420px) {
          margin-bottom: 10px;
          padding: 0 10px;
        }

        .calender {
          padding-right: 12px;
        }
        .down {
          padding-left: 12px;
        }
      }
      .email_btn,
      .download_btn {
        background: rgba(85, 126, 251, 0.1);
        border-radius: 4px;
        // max-width: 87px;
        // width: 100%;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        color: var(--theme-color);
        padding-left: 10px !important;
        padding-right: 10px;
        border: none;
        margin-left: 12px;
        &.download {
          max-width: 120px;
          &:hover {
            background: rgba(85, 126, 251, 0.1) !important;
          }
        }
        @media (max-width: 530px) {
          margin-left: 0px;
        }
        @media (max-width: 420px) {
          margin-left: 0px;
        }
        span {
          padding-right: 8px;
        }
        &:focus {
          outline: none;
          border: none;
        }
      }
      .download_btn {
        // max-width: 89px;
        height: 43px;
        width: 100%;
        // justify-content: flex-start;
        background: none;
        @media (max-width: 530px) {
          margin-left: 70px;
        }
        @media (max-width: 420px) {
          margin-left: 0px;
        }
      }
    }
  }
  .subscription_list {
    //max-width: 915px;
    font-family: "Nunito", sans-serif;
    width: 100%;
    background: #ffffff;
    margin-bottom: 20px;
    filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.08));
    border-radius: 8px;
    .single_list {
      align-items: center;
      // padding: 20px;
      border-bottom: 1px solid #ddd;
      height: 78px;
      @media (max-width: 875px) {
        height: 90px;
      }
      p {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;

        display: flex;
        align-items: center;
        color: #474d52;
        margin: 0;
        margin-left: 24px;
        @media (max-width: 875px) {
          margin-top: 10px;
        }
      }
      .list_details {
        display: flex;
        align-items: center;
        .sub_price {
          margin-right: 68px;
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 22px;

          display: flex;
          align-items: center;

          /* Body */

          color: #474d52;
          @media (max-width: 875px) {
            margin-left: 24px;
          }
          @media (max-width: 460px) {
            margin-right: 5px;
          }
        }
        .email_btn {
          margin-right: 16px;
          @media (max-width: 450px) {
            margin-right: 10px;
          }
        }
        .email_btn,
        .download_btn {
          background: rgba(85, 126, 251, 0.1);
          border-radius: 4px;
          // max-width: 87px;
          // width: 100%;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          color: var(--theme-color);
          border: none;
          margin-left: 12px;

          @media (max-width: 450px) {
            margin-left: 0px;
          }
          span {
            padding-right: 8px;
          }
          &:focus {
            outline: none;
            border: none;
          }
        }
        .download_btn:hover {
          background: rgba(85, 126, 251, 0.1) !important;
        }
        .download_btn {
          // max-width: 89px;
          height: 43px;
          width: 100%;
          // justify-content: flex-start;
          background: none;
          margin-right: 24px;
          @media (max-width: 460px) {
            margin-right: 5px;
          }
        }
      }
    }
  }
}
#deleteCard,
#subscribe {
  h3 {
    text-align: center;
    margin: 24px 0;
    margin-top: 8px;
  }
  p {
    text-align: center;
    margin-bottom: 27px;
  }
  .warning-msg {
    margin: 24px 0;
    .card-element {
      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 11px;
      padding-right: 11px;
      margin-top: 5px;
      margin-bottom: 5px;
      background: #dde2e9;
      border-radius: 4px;
      border-color: transparent;
    }
    .card-errors {
      font-size: 10px;
      color: red;
    }
    p {
      text-align: center;
      margin: 0;
    }
  }
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
}
#subscribe {
  .btn-round-fill {
    background: var(--theme-color);
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.07);
    border-radius: 100px;
    color: #fff !important;
    border: none !important;
  }
  .lightFont {
    color: #b3c2cb !important;
  }
}
.price-card {
  font-family: "Nunito", sans-serif;
  filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.08));
  background: #ffffff;
  border-radius: 8px;

  width: 100%;
  margin-bottom: 10px;

  @media (max-width: 767px) {
    margin-left: auto;
    margin-right: auto;
    // min-width: 350px;
    // min-width: 100%;
    max-width: 350px;
  }
  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.05em;
    margin-top: 32px;
    margin-bottom: 14px;

    color: #474d52;
  }
  .price {
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    display: flex;
    align-items: center;
    text-align: center;

    margin-bottom: 18px;
    color: #474d52;
  }
  .month {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.05em;
    color: #474d52;
  }
  .features {
    margin-top: 32px;
    p {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;

      display: flex;
      align-items: center;
      letter-spacing: 0.03em;

      /* Secondary */

      color: #8d99a0;
      margin-bottom: 16px;
    }
  }

  .btn-round-fill {
    max-width: 205px !important;
    width: 100%;
    height: 48px !important;
    font-style: normal;
    font-weight: normal !important;
    font-size: 16px;
    font-family: "Nunito", sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #ffffff;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.07);
    border-radius: 100px !important;
    border: none;
    margin-bottom: 24px;
    margin-top: 32px !important;
    &.activee {
      background: rgba(85, 126, 251, 0.1) !important;
      color: var(--theme-color);
      &:hover {
        background: var(--theme-color) !important;
        color: #fff;
      }
    }
  }
}
.no-shadow {
  box-shadow: none !important;
}
.email_btn:hover {
  background-color: var(--theme-color) !important;
  background: var(--theme-color) !important;
  color: #fff !important;
  svg {
    path {
      fill: #fff !important;
    }
  }
}
.calendar_wrapper {
  position: absolute;
  top: 100%;
  left: 50%;
  z-index: 1;
  transform: translateX(-50%);
  display: flex;
}
</style>
